export const mappingSettings = (settings) => {
    const signaturesMapped = settings.signatures.map((signature) => {
        return {
            ...signature,
            id: Number(signature.id),
            is_default: Number(signature.is_default),
        };
    });
    return {
        is_simple_signature: Number(settings.is_simple_signature),
        signatures: signaturesMapped,
    };
};
